/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1DomainsGetDomainRequestBody = {
  /**
   * Identifies a domain by its Teral ID or by its name. Pass a 'dom_'-prefixed ID, or a fully
   *
   * @remarks
   * qualified domain name such as 'api.acme.com' without a scheme, port, or path. You can give an
   * internationalized name in Unicode or Punycode form. Both forms address the same domain.
   *
   * Domain names are unique per workspace, so the name alone addresses the domain. You do not
   * need to supply a project, app, or environment.
   */
  domain: string;
};

/** @internal */
export type V1DomainsGetDomainRequestBody$Outbound = {
  domain: string;
};

/** @internal */
export const V1DomainsGetDomainRequestBody$outboundSchema: z.ZodType<
  V1DomainsGetDomainRequestBody$Outbound,
  z.ZodTypeDef,
  V1DomainsGetDomainRequestBody
> = z.object({
  domain: z.string(),
});

export function v1DomainsGetDomainRequestBodyToJSON(
  v1DomainsGetDomainRequestBody: V1DomainsGetDomainRequestBody,
): string {
  return JSON.stringify(
    V1DomainsGetDomainRequestBody$outboundSchema.parse(
      v1DomainsGetDomainRequestBody,
    ),
  );
}
